import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';

import {Observable, Subscription} from 'rxjs';
import {ProcessService} from '../../../_services/process.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {BaseWebservice} from '../../../../shared/base/base.webservice';

@Component({
  selector: 'app-gift-summary',
  templateUrl: './gift-summary.component.html',
  styleUrls: ['./gift-summary.component.scss']
})
export class GiftSummaryComponent implements OnInit {
    @Input("isFinish") isFinish = false;

    level = 402
    defaultAuth: any = {
        maritalStatus: '',

    };

    executorList: { name, dob, email, isSelected }[] = [
        // {name: 'Jenny Vitug Dela Cruz', dob: '12-25-1986', email: "Jenny@gmail.com", isSelected:undefined},
        // {name: 'Gary Cruz', dob: '11-02-1966', email: "Gary@gmail.com", isSelected:undefined}
    ]


    hasError: boolean;

    isLoading$: Observable<boolean>;
    isCurrentProcessStatusComplete = false;
    private unsubscribe: Subscription[] = [];
    details: any[] = [];


    constructor(

        private processService: ProcessService,
        private route: ActivatedRoute,
        private router: Router,
        private _httpClient: HttpClient,
        private ngxLoader: NgxUiLoaderService,
        private _globalService: BaseWebservice,
        private _cd: ChangeDetectorRef
    ) {
        // this.isLoading$ = this.authService.isLoading$;
        this.isCurrentProcessStatusComplete = !!(this._globalService.fetchProcessListingLevel('gifts')) && (this._globalService.fetchProcessListingLevel('gifts')) >= this.level
        this.isCurrentProcessStatusComplete = this._globalService.isPlanBronze()
        this.unsubscribe.push(this._globalService.navigation$.subscribe(value => {
            if(value == 'next') {
                this.navigateToNextPage();
            }
            if(value == 'prev') {
                this.moveBack()
            }
        }))
    }

    moveBack() {
        this.router.navigate([`/${this._globalService.getContentForPage().previousPage}`])

    }

    ngOnInit(): void {


        this._globalService.setContentData()


        this.processService.getUserDetails().subscribe(response => {
            if(response['success'] == true) {
                this.details = response['data']['gifts'].filter(value => value.hasGifts == true)
            } else {
            }
        })


        if(!this._globalService.getProcessStatus("gifts") &&!this.isFinish ) {
            this.processService.setProcessStep({step: "gifts"}).subscribe(response => {
                if (response['success'] == true) {


                } else {

                }
            })
        }

    }




    submit() {
        this.hasError = false;
        this._globalService.updateProcessListingLevel('gifts', this._globalService.getContentForPage().level)
        // this.isCurrentProcessStatusComplete = false


    }

    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }

    navigateToNextPage() {
        this._globalService.appGlobalProgressStatus("gifts")
        this.router.navigate([`/`])

    }


    giftSelection() {

    }

    goBacktoGifts() {
        this.router.navigate([`/gifts`])

    }

    editProfile() {
        this.router.navigate([`/gifts`])
    }
}
